import API from "@aws-amplify/api";
import Log from "../utils/Log";
import { formatDate } from "../utils/monetizationUtils"
import { combineNetworks } from "../utils/reducerHelperUtils";
// import {
//   // gamAccount,
//   mockTransactionsData,
//   newMockTransactionsData,
//   mockEarningsData,
//   mockProjectsData,
//   newMockProjectsData,
// } from "../mock/stub/monetization";

type IAdBoxNetworkReportItem = bb.model.monetization.IAdBoxNetworkReportItem

export const fetchAdPaymentHistory = (accessToken:string):Promise<any> => {
  return new Promise((resolve, reject) => {
    API.get("adsURL", "revshare/transactions", {
      headers: {
        "Content-Type": "application/json",
        Token: accessToken,
      },
      response: true,
    })
      .then((res) => {
        const { status } = res;
        if (status === 200) {
          Log.info(res.data, "SUCCESS - fetchAdPaymentHistory response:");

          resolve(res.data);
        }
      })
      .catch((e:any) => {
        if (e) {
          Log.error(e, "error caught in fetchAdPaymentHistory");

          reject(e.response?.data?.error);
        }
      });
  });
};

export const fetchTotalEarningsToBePaid = (accessToken: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    API.get("adsURL", "reporting/earnings/lastmonth", {
      headers: {
        "Content-Type": "application/json",
        Token: accessToken,
      },
      response: true,
    })
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          Log.info(res.data, "SUCCESS - fetchTotalEarningsToBePaid response:");
          resolve (res.data);
        }
      })
      .catch((error:any) => {
        if (error) {
          Log.error(error, "error caught in fetchTotalEarningsToBePaid");
          reject(error)
        }
      })
  });
};

export const fetchRegistrationStatus = (accessToken:string):Promise<any> => {
  return new Promise((resolve, reject) => {
    API.get("adsURL", "revshare/user/status", {
      headers: {
        "Content-Type": "application/json",
        Token: accessToken,
      },
      response: true,
    })
      .then((res) => {
        Log.info(res.data, "SUCCESS - fetchRegistrationStatus response:");

        const { status } = res;
        if (status === 200) {
          resolve(res.data.payload);
        }
      })
      .catch((e:any) => {
        if (e) {
          if (e.response.status === 404) {
            Log.info(
              e.response.data,
              "UNREGISTERED - fetchRegistrationStatus response:"
            );

            resolve({
              status: "UNREGISTERED",
              verificationStatus: "NOT_REQUIRED",
            });
          } else {
            Log.error(e, "error caught in fetchRegistrationStatus");

            reject(e.response?.data?.error);
          }
        }
      });
  });
};
export const fetchHyperWalletUser = (accessToken:string):Promise<any> => {
  return new Promise((resolve, reject) => {
    API.get("adsURL", "revshare/user/retrieve", {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Token: accessToken,
      },
      response: true,
    })
      .then((res) => {
        const { status } = res;
        if (status === 200) {
          Log.info(res.data, "SUCCESS - fetchHyperWalletUser response:");

          resolve(res.data.payload);
        }
      })
      .catch((e:any) => {
        Log.error(e, "error caught in fetchHyperWalletUser");

        reject(e.response?.data?.error);
      });
  });
};

export const createHyperWalletUser = (fields:any, accessToken:string):Promise<any> => {
  console.log("fields", fields);
  return new Promise((resolve, reject) => {
    API.post("adsURL", "revshare/user/register", {
      body: {
        firstName: fields.firstName,
        lastName: fields.lastName,
        dateOfBirth: fields.dateOfBirth,
        email: fields.email,
        country: fields.country,
      },
      headers: {
        "Content-Type": "application/json",
        Token: accessToken,
      },
      response: true,
    })
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          Log.info(res.data, "SUCCESS - registerHyperwalletUser response:");
          resolve(res.data);
        }
      })
      .catch((error:any) => {
        if (error) {
          Log.error(error, "error caught in registerHyperwalletUser");
          if (error.response.status === 400) {
            reject(
              error.response.data.error + "- please try a different email."
            );
          } else {
            reject(error.response?.data?.error);
          }
        }
      });
  });
};

export const updateHyperWalletUser = (fields:any, accessToken:string):Promise<any> => {
  return new Promise((resolve, reject) => {
    API.post("adsURL", "revshare/user/update", {
      body: {
        firstName: fields.firstname,
        lastName: fields.lastname,
        dateOfBirth: fields.dateOfBirth,
        email: fields.email,
        country: fields.country,
      },
      headers: {
        "Content-Type": "application/json",
        Token: accessToken,
      },
      response: true,
    })
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          Log.info(res.data, "SUCCESS - updateHyperwalletUser response:");
          resolve(res.data);
        }
      })
      .catch((error:any) => {
        if (error) {
          Log.error(error, "error caught in updateHyperwalletUser");
          reject(error);
        }
      });
  });
};
export const fetchExportByBundleId = (bundleId:string) => {
  return new Promise((resolve, reject) => {
    API.post("adsURL", `revshare/exports/${bundleId}`, {
      headers: {
        "Content-Type": "application/json",
      },
      response: true,
    })
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          Log.info(res.data, "SUCCESS - fetchExportByBundleId response:");
          resolve(res.data);
        }
      })
      .catch((error:any) => {
        if (error) {
          Log.error(error, "error caught in fetchExportByBundleId");
          reject(error);
        }
      });
  });
};

export const fetchProjects = (accessToken:string):any => {
  return new Promise((resolve, reject) => {
    API.get("adsURL", "revshare/exports", {
      headers: {
        "Content-Type": "application/json",
        Token: accessToken,
      },
      response: true,
    })
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          Log.info(res.data, "SUCCESS - fetchProjects response:");
          resolve(res.data);
        }
      })
      .catch((error:any) => {
        if (error) {
          Log.error(error, "error caught in fetchProjects");
          reject(error);
        }
      });
  });
};


export const fetchAdboxReport = async (accessToken: string, startDate: Date, endDate: Date, exclude_columns: Array<string>): Promise<IAdBoxNetworkReportItem[]> => {
  try {
    // console.log(exclude_columns.length > 0 ? `reporting/range/${formatDate(startDate)}/${formatDate(endDate)}?exclude_columns=${[...exclude_columns]}` : `reporting/range/${formatDate(startDate)}/${formatDate(endDate)}`);
    const urlLink:string = exclude_columns.length > 0 ? `reporting/range/${formatDate(startDate)}/${formatDate(endDate)}?exclude_columns=${[...exclude_columns]}` : `reporting/range/${formatDate(startDate)}/${formatDate(endDate)}`;
    const res = await API.get("adsURL", urlLink, {
      headers: {
        "Content-Type": "application/json",
        Token: accessToken,
        // TODO: add this to EVERY bb-platform request
        "web-client-version": '1.1'
      },
      response: true
    })
    if (res.status !== 200) {
      throw new Error("unexpected status code: "+res.status)
    }

    const combined = combineNetworks(res.data.payload)
    return combined
    // return res.data.payload as IAdboxReportItem[]
  }
  catch (error:any) {
    Log.error(error, "error caught in fetchProjects")
    throw error
  }
}

export const fetchAdboxMonthToDate = async (accessToken: string):Promise<{earnings:{net:number}}> => {

  try {
    const res = await API.get("adsURL", "reporting/earnings/monthtodate", {
      headers: {
        "Content-Type": "application/json",
        Token: accessToken
      },
      response: true
    })
    if (res.status !== 200) {
      throw new Error("unexpected status code: "+res.status)
    }
    return res.data.payload;
  }
  catch (error:any) {
    Log.error(error, "error caught in fetchProjects")
    throw error
  }


}

export const fetchAdboxDailyMetrics = async (accessToken: string, startDate: Date, endDate: Date):Promise<{totals: any[], items: any[]}> => {

  const urlLink:string = `reporting/daily/range/${formatDate(startDate)}/${formatDate(endDate)}`;

  try {
    const res = await API.get("adsURL", urlLink, {
      headers: {
        "Content-Type": "application/json",
        Token: accessToken
      },
      response: true
    })
    if (res.status !== 200) {
      throw new Error("unexpected status code: "+res.status)
    }
    return res.data.payload;
  }
  catch (error:any) {
    Log.error(error, "error caught in fetchProjects")
    throw error
  }


}
